import { render } from "./AlzataFormComponent.vue?vue&type=template&id=31ef8d6e"
import script from "./AlzataFormComponent.vue?vue&type=script&lang=js"
export * from "./AlzataFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "C:\\stuff\\dfob\\adminui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__